<template>
  <div>
    <el-form
      v-if="showPage"
      class="setp-form"
      ref="step1form"
      :rules="rules"
      :model="form"
      label-width="155px"
      size="small"
    >
      <el-form-item label="学年" prop="schoolYear">
        <school-year-selector
          v-model="form.schoolYear"
          @change="refreshUser"
        ></school-year-selector>
      </el-form-item>
      <el-form-item label="学期" prop="schoolTerm">
        <school-term-selector
          v-model="form.schoolTerm"
          @change="refreshUser"
          :checkAll="false"
        ></school-term-selector>
      </el-form-item>
      <el-form-item label="年级" prop="gradeObj">
        <el-select
          @change="refreshUser"
          v-model="form.gradeObj"
          placeholder="请选择"
          clearable
          value-key="grade"
        >
          <el-option
            v-for="item in gradeOptions"
            :key="item.id"
            :label="item.gradeName"
            :value="{ grade: item.grade, gradeName: item.gradeName }"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="学科" prop="disciplineCodeObj">
        <el-select
          @change="refreshUser"
          v-model="form.disciplineCodeObj"
          placeholder="请选择"
          clearable
          value-key="disciplineCode"
        >
          <el-option
            v-for="item in disciplineOptions"
            :key="item.id"
            :label="item.disciplineName"
            :value="{
              disciplineCode: item.disciplineCode,
              disciplineName: item.disciplineName
            }"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="活动主题" prop="actTitle">
        <el-input
          v-model="form.actTitle"
          style="width: 400px"
          maxlength="20"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="周次" prop="actWeek">
        <el-input
          v-model="form.actWeek"
          style="width: 200px"
          type="number"
          min="0"
        ></el-input>
      </el-form-item>
      <el-form-item label="活动类型" prop="validatorActive">
        <dic-code-selector
          style="margin-right: 10px"
          dicType="researchLevel"
          v-model="form.classify1"
        ></dic-code-selector>
        <dic-code-selector
          dicType="researchType"
          v-model="form.classify2"
        ></dic-code-selector>
      </el-form-item>
      <el-form-item label="活动时间" prop="allDate">
        <el-date-picker
          v-model="form.allDate"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="活动地点" prop="address">
        <el-input
          v-model="form.address"
          style="width: 400px"
          maxlength="50"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="召集人">
        <el-input
          v-if="form.actCode"
          v-model="form.createName"
          style="width: 400px"
          disabled
        ></el-input>
        <el-input
          v-else
          v-model="userInfo.userName"
          style="width: 400px"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item prop="speakUsers" label="主讲人">
        <el-select
          size="small"
          style="width: 500px"
          value-key="userId"
          filterable
          v-model="form.speakUsers"
          :filter-method="filterMethod"
          placeholder="请选择主讲人"
          @visible-change="UsersChange"
          multiple
        >
          <el-option
            v-for="item in joinUsersOptions"
            :value="{
              userId: item.teacherId,
              userName: item.teacherName,
              schoolCode: item.schoolCode
            }"
            :label="item.teacherName"
            :key="item.teacherId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="joinUsers" label="参与教师">
        <el-checkbox
          :checked="form.isAll"
          v-model="form.isAll"
          @change="isAllChange"
          >教研组所有成员</el-checkbox
        >
        <br />
        <el-select
          size="small"
          style="width: 500px"
          value-key="userId"
          filterable
          v-model="form.joinUsers"
          :filter-method="filterMethod"
          placeholder="请选择参与教师"
          @visible-change="UsersChange"
          multiple
        >
          <el-option
            v-for="item in joinUsersOptions"
            :value="{
              userId: item.teacherId,
              userName: item.teacherName,
              schoolCode: item.schoolCode
            }"
            :label="item.teacherName"
            :key="item.teacherId"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="活动目的与要求" prop="actContent">
        <el-input
          v-model="form.actContent"
          style="width: 600px"
          maxlength="200"
          show-word-limit
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 8 }"
          placeholder="请输入活动目的与要求"
        ></el-input>
      </el-form-item>
      <el-form-item label="活动方案" prop="actPlan">
        <el-input
          v-model="form.actPlan"
          style="width: 600px"
          maxlength="200"
          show-word-limit
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 8 }"
          placeholder="请输入活动方案"
        ></el-input>
      </el-form-item>
      <el-form-item prop="schemeAttaches">
        <upload-link
          ref="linkBatchImport"
          accept="*"
          :fileLimit="15"
          @changeUpload="changeUpload"
          @uploadloading="uploadloading"
          :fileList="form.schemeAttaches"
        >
          <template slot="body">
            <el-button :loading="btnLoading" size="small" type="primary"
              >点击上传</el-button
            >
          </template>
        </upload-link>
      </el-form-item>
      <el-form-item label="活动内容" prop="contentFormListVal">
        <div
          class="box-active-content"
          v-for="(ci, index) in contentFormList"
          :key="ci.contentId"
        >
          <el-form
            class="content-form"
            ref="contentFormList"
            :model="ci"
            label-width="90px"
            size="small"
            style="padding: 10px 20px"
          >
            <el-button
              type="plain"
              size="small"
              class="el-icon-plus addlink"
              @click="addLink(ci.contentId)"
              >活动环节</el-button
            >
            <ul class="link-ul">
              <li
                class="clearfix"
                v-for="(i, index) in ci.activeNodeTopicForms"
                :key="i.id"
              >
                <span class="fl">{{ index + 1 }}</span>
                <div class="desc fl">
                  <h1>{{ i.topic }}</h1>
                  <h2>
                    <i :class="mapLinkIcon(i.nodeType)"></i>
                    {{
                      nodeList.length > 0
                        ? nodeList.find((item) => item.nodeType == i.nodeType)
                            .nodeDesc
                        : ''
                    }}
                  </h2>
                </div>
                <div class="do fr">
                  <!-- <el-button type="text">查看</el-button> -->
                  <el-button type="text" class="edit-but" @click="editLink(i)"
                    >编辑</el-button
                  >
                  <el-button type="text" class="del-but" @click="delLink(i)"
                    >删除</el-button
                  >
                </div>
              </li>
            </ul>
          </el-form>
        </div>
      </el-form-item>
      <div>
        <el-button
          :loading="btnLoading"
          class="sub-form"
          size="small"
          @click="submitForm"
          type="primary"
          >发 布</el-button
        >
      </div>
    </el-form>
    <!-- 选择环节弹框 -->
    <el-dialog
      :visible.sync="linkAddPop"
      top="12%"
      width="700px"
      class="link-pop"
    >
      <div class="add-content">
        <h2>添加文档</h2>
        <span
          v-for="i in nodeList.filter((i) => i.classify === 'content')"
          :key="i.nodeType"
          class="clrarfix"
          @click="tabChange(i)"
        >
          <i :class="mapLinkIcon(i.nodeType)"></i>
          <em>{{ i.nodeDesc }}</em>
          <i class="fr el-icon-plus"></i>
        </span>
        <h2>添加互动</h2>
        <span
          v-for="i in nodeList.filter((i) => i.classify === 'interact')"
          :key="i.nodeType"
          class="clrarfix"
          @click="tabChange(i)"
        >
          <i :class="mapLinkIcon(i.nodeType)"></i>
          <em>{{ i.nodeDesc }}</em>
          <i class="fr el-icon-plus"></i>
        </span>
      </div>
    </el-dialog>
    <div v-loading="!showPage"></div>
  </div>
</template>
<script>
import schoolTermSelector from '@/components/school/schoolTermSelector.vue'
import schoolYearSelector from '@/components/school/schoolYearSelector.vue'
import UploadLink from '@/components/upload/UploadLink.vue'
import { getData, postData, postJson } from '@/http/fetch.js'
import { mapLinkIcon } from '@/utils/index.js'
import { mapGetters, mapState } from 'vuex'

import DicCodeSelector from '@/components/common/DicCodeSelector.vue'
import Face from '@/components/common/Face.vue'
export default {
  components: {
    Face,
    DicCodeSelector,
    schoolYearSelector,
    schoolTermSelector,
    UploadLink
  },
  computed: {
    ...mapState(['userInfo', 'schoolList', 'topicLink']),
    ...mapGetters(['schoolCodes']),
    orgOptions: function () {
      let orgList = [
        {
          orgCode:
            this.userInfo.teacherSchoolList[0].orgCode ||
            this.userInfo.teacherSchoolList[0].schoolCode,
          orgName:
            this.userInfo.teacherSchoolList[0].orgName ||
            this.userInfo.teacherSchoolList[0].schoolName
        }
      ]
      return orgList
    }
  },
  data() {
    var validatorActiveType = (rule, value, callback) => {
      if (this.form.classify1 === '' || this.form.classify2 === '') {
        return callback(new Error('请完善活动类型'))
      } else {
        callback()
      }
    }
    var validatorContent = (rule, value, callback) => {
      this.contentFormList.forEach((ci, index) => {
        if (ci.activeNodeTopicForms.length === 0) {
          return callback(new Error('请完善活动内容的信息 ！'))
        } else if (index === this.contentFormList.length - 1) {
          //最后一个
          callback()
        }
      })
    }

    return {
      subLoding: false,
      showPage: false,
      btnLoading: false,
      contentId: '',
      gradeOptions: [],
      disciplineOptions: [],
      joinUsersOptions: [],
      form: {
        actType: 'research', //活动
        actTitle: '', //活动主题
        actWeek: '', //活动周次
        grade: '',
        gradeObj: '',
        disciplineCodeObj: '',
        classify1: '',
        classify2: '',
        classify4: '', //活动类型
        allDate: [], //startDate:"",endDate:"",
        startDate: '',
        endDate: '',
        operatorId: '',
        speakUsers: [], //主讲人
        otherSchoolUsers: [],
        actPlan: '', //方案
        actContent: '', //内容
        orgCode: '', //集团代码
        schoolCode: '', //校区代码
        address: '',
        schoolYear: '',
        schoolTerm: '',
        isAttachVisible: 1,
        subInfoFormList: [], //子活动内容
        disciplineName: '',
        disciplineCode: '',
        activeNodeTopicForms: [],
        joinUsers: [],
        isAll: false,
        schemeAttaches: [] //附件
      },
      rules: {
        actTitle: [
          {
            required: true,
            message: '请输入活动主题',
            trigger: 'blur'
          }
        ],
        actWeek: [
          {
            required: true,
            message: '请输入活动周次',
            trigger: 'blur'
          }
        ],
        address: [
          {
            required: true,
            message: '请输入活动地点',
            trigger: 'blur'
          }
        ],
        schoolYear: [
          { required: true, message: '请选择学年', trigger: 'blur' }
        ],
        schoolTerm: [
          { required: true, message: '请选择学期', trigger: 'blur' }
        ],
        gradeObj: [{ required: true, message: '请选择年级', trigger: 'blur' }],
        disciplineCodeObj: [
          { required: true, message: '请选择学科', trigger: 'change' }
        ],
        validatorActive: [
          { validator: validatorActiveType, required: true, trigger: 'blur' }
        ],
        speakUsers: [
          { message: '请选择主讲人', required: true, trigger: 'blur' }
        ],
        joinUsers: [
          { message: '请选择参与人员', required: true, trigger: 'blur' }
        ],
        // 子活动
        contentFormListVal: [
          { validator: validatorContent, required: true, trigger: 'change' }
        ],
        allDate: [
          {
            required: true,
            message: '请选择活动时间',
            trigger: 'change'
          }
        ],
        actContent: [
          {
            required: true,
            message: '请输入活动目的与要求',
            trigger: 'blur'
          }
        ],
        actPlan: [
          {
            required: true,
            message: '请输入活动方案',
            trigger: 'blur'
          }
        ]
      },
      //子活动内容
      contentFormList: [
        {
          contentId: new Date().getTime(),
          //环节信息
          activeNodeTopicForms: []
        }
      ],
      //环节 弹框
      linkAddPop: false,
      nodeList: [],
      linkFormPop: true
    }
  },
  created() {
    this.init()
  },
  methods: {
    mapLinkIcon,
    async init() {
      this.showPage = false
      await this.getGradeList()
      await this.getDiscipline()
      //回显
      if (sessionStorage.getItem('actCode')) {
        let activeInfo = await getData('/researchGroup/getActiveInfo', {
          actCode: sessionStorage.getItem('actCode'),
          operatorId: this.userInfo.userId
        })
        this.form = { ...activeInfo }
        this.$set(
          this.form,
          'speakUsers',
          activeInfo.speakUsers.map((u) => ({
            userId: u.userId,
            userName: u.userName,
            schoolCode: u.schoolCode
          }))
        )
        this.$set(this.form, 'gradeObj', {
          grade: activeInfo.grade,
          gradeName: activeInfo.gradeName
        })
        this.$set(this.form, 'disciplineCodeObj', {
          disciplineCode: activeInfo.disciplineCode,
          disciplineName: activeInfo.disciplineName
        })
        this.$set(this.form, 'allDate', [
          activeInfo.startDate,
          activeInfo.endDate
        ])
        this.contentFormList = [
          {
            contentId: activeInfo.id,
            activeNodeTopicForms: activeInfo.activeNodeTopics
          }
        ]
        await this.getTeacherInfoList()
        if (activeInfo.joinUsers.length >= this.joinUsersOptions.length) {
          this.form.isAll = true
        }
        //回显环节
        this.initLink(this.contentFormList)
      }
      this.showPage = true
      await this.getNodeList()
    },
    uploadloading(Bool) {
      this.subLoding = Bool
      this.btnLoading = Bool
    },
    changeUpload(fileList) {
      fileList.forEach((i) => {
        if (!i.name) {
          i.name = i.attachName
        }
      })
      this.form.schemeAttaches = fileList
    },
    async getNodeList() {
      //得到环节配置
      this.nodeList = await getData('/research/getSysNodeConfigList')
    },
    async getTeacherInfoList(query = '') {
      // if (!isRe) {
      //   this.form.joinUsers = [];
      // }
      return new Promise((resove, reject) => {
        postData('/researchGroup/getGroupTeacherList', {
          schoolCode: this.userInfo.schoolCode,
          grade: this.form.grade,
          disciplineCode: this.form.disciplineCode,
          schoolYear: this.form.schoolYear,
          schoolTerm: this.form.schoolTerm,
          keyword: query
        }).then((res) => {
          if (res.length) {
            this.joinUsersOptions = res
            resove(res)
          } else {
            this.joinUsersOptions = []
            reject()
          }
        })
      })
    },
    async UsersChange(bool) {
      if (bool) {
        if (!this.form.schoolYear) {
          this.$message.warning('请先选择学年！')
          return
        }
        if (!this.form.schoolTerm) {
          this.$message.warning('请先选择学期！')
          return
        }
        if (!this.form.grade) {
          this.$message.warning('请先选择年级！')
          return
        }
        if (!this.form.disciplineCode) {
          this.$message.warning('请先选择学科！')
          return
        }
        await this.getTeacherInfoList()
      }
    },
    refreshUser() {
      if (
        this.form.schoolYear &&
        this.form.schoolTerm &&
        this.form.grade &&
        this.form.disciplineCode
      ) {
        this.form.joinUsers = []
        this.form.speakUsers = []
        this.filterMethod('')
      }
    },
    async filterMethod(query) {
      if (this.joinUsersOptions.length == 0) {
        await this.getTeacherInfoList()
      } else {
        await this.getTeacherInfoList(query)
      }
    },
    async getGradeList() {
      this.gradeOptions = await postData('/school/getGradeList', {
        schoolCode: this.userInfo?.schoolCode
      })
      return new Promise((resolve) => {
        resolve()
      })
    },
    async getDiscipline() {
      this.disciplineOptions = await postData(
        '/discipline/getDisciplinelList',
        {
          schoolCode: this.userInfo?.schoolCode
        }
      )
      return new Promise((resolve) => {
        resolve()
      })
    },
    async submitForm() {
      try {
        this.btnLoading = true
        await this.$refs.step1form.validate()
        this.form.activeNodeTopicForms =
          this.contentFormList[0].activeNodeTopicForms
        this.form.schoolCode = this.userInfo.schoolCode
        this.form.operatorId = this.userInfo.userId
        if (!this.form.orgCode) {
          this.form.orgCode = this.orgOptions[0].orgCode
        }
        if (!this.form.classify4) {
          this.form.classify4 = -1
        }
        await postJson(
          '/researchGroup/saveOrUpdateActiveResearchInfo',
          this.form
        )
        this.btnLoading = false
        this.cleanLink()
        this.$message.success('发布成功！')
        this.$router.push({ name: 'researchGroupAct' })
      } catch (err) {
        console.log('err', err)
        this.btnLoading = false
      }
    },
    resetForm() {
      this.$refs.step1form.resetFields()
    },
    ///////////////////////////////环节
    //回显link
    initLink(contentList) {
      let storeLinkList = []
      contentList.forEach((ci) => {
        ci.activeNodeTopicForms &&
          ci.activeNodeTopicForms.forEach((li) => {
            li.contentId = ci.contentId
            li.tempId = li.id
            storeLinkList.push(li)
          })
      })
      this.$store.commit('initTopicLink', storeLinkList)
    },
    addLink(contentId) {
      this.nodeList.forEach((i) => {
        i.contentId = contentId
      }) //加一个 当前内容的id
      this.linkAddPop = true
    },
    tabChange(info) {
      this.linkAddPop = false
      this.$emit('changTab', 'linkAdd', info)
    },
    cleanLink() {
      this.$store.commit('cleanTopicLink')
    },
    delLink(i) {
      this.$store.commit('delTopicLink', i.tempId)
    },
    editLink(info) {
      this.$emit('changTab', 'linkAdd', info)
    },
    async isAllChange(val) {
      if (val) {
        await this.UsersChange(val)
        this.form.joinUsers = this.joinUsersOptions.map((item) => ({
          userId: item.teacherId,
          userName: item.teacherName,
          schoolCode: item.schoolCode
        }))
      }
    }
  },
  watch: {
    'form.allDate': {
      handler(val, oldVal) {
        if (val.length > 0) {
          this.form.startDate = val[0]
          this.form.endDate = val[1]
        }
      }
    },
    'form.disciplineCodeObj': {
      handler(val, oldVal) {
        if (val) {
          this.form.disciplineCode = val.disciplineCode
          this.form.disciplineName = val.disciplineName
        }
      }
    },
    'form.gradeObj': {
      handler(val, oldVal) {
        if (val) {
          this.form.grade = val.grade
          this.form.gradeName = val.gradeName
        }
      }
    },
    //store 中的topicLink ； 对contentFormList[0].activeNodeTopicForms环节进行赋值
    //contentId 环节中的内容id
    topicLink: {
      handler(val, oldVal) {
        if (val.length === 0) {
          this.contentFormList.forEach((i) =>
            this.$set(i, 'activeNodeTopicForms', [])
          )
        } else {
          this.contentFormList.forEach((i) => {
            if (val.map((vi) => vi.contentId).includes(i.contentId)) {
              this.$set(
                i,
                'activeNodeTopicForms',
                val.filter((svi) => svi.contentId == i.contentId)
              )
            }
          })
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped>
.setp-form {
  padding-top: 15px;
  padding-bottom: 30px;
  width: 830px;
  margin: 0 auto;
}

.sub-form {
  margin-top: 30px;
  margin-left: 380px;
}

.scorll-list {
  padding: 2px;
  border: 1px solid rgb(231, 227, 227);
  border-radius: 5px;
  min-height: 30px;
  max-height: 128px;
  overflow: auto;

  .el-tag {
    margin: 3.5px;
    padding: 0px 5px;
  }
}

.box-active-content {
  position: relative;
  left: 0px;
  top: 0px;
  width: 610px;
  margin-top: 5px;
  margin-bottom: 10px;
  border-radius: 5px;
  border: 1px solid rgb(212, 208, 208);
  padding: 15px 0px;
  padding-bottom: 0px;

  .content-del {
    position: absolute;
    right: -35px;
    top: 0px;
    font-size: 20px;
    padding: 5px;
  }

  .content-plus {
    position: absolute;
    right: -35px;
    top: 35px;
    font-size: 20px;
    padding: 5px;
  }

  .el-divider--horizontal {
    margin: 0px 0px 15px 0px;
  }

  .addlink {
    border: 1px solid @color;
    color: @color;
    padding: 6px 10px;
  }
}

/deep/.link-pop .el-dialog {
  border-radius: 20px;

  .add-content {
    padding: 0px 20px;

    h2 {
      font-size: 17px;
      font-weight: 700;
      margin-bottom: 25px;
    }

    span {
      cursor: pointer;
      vertical-align: middle;
      display: inline-block;
      width: 170px;
      color: @color;
      border-radius: 5px;
      background: #eee;
      padding: 12px 17px;
      font-size: 16px;
      margin-right: 35px;
      margin-bottom: 35px;

      em {
        color: rgb(59, 58, 58);
        margin-left: 15px;
      }

      i {
        vertical-align: middle;
        font-weight: 700;
        font-size: 20px;
      }

      i:nth-of-type(2) {
        font-size: 21px;
      }
    }
  }
}

.link-ul {
  margin-top: 10px;
  padding-left: 0px;

  li {
    border-radius: 8px;
    padding: 0px 10px;
    cursor: pointer;
    border: 1px solid #dfd6d6;

    span {
      margin-top: 13px;
      border: 2px solid @color;
      color: @color;
      height: 28px;
      width: 28px;
      font-size: 20px;
      border-radius: 50%;
      text-align: center;
      line-height: 20px;
    }

    .desc {
      h1 {
        font-size: 15px;
        padding-left: 10px;
      }

      h2 {
        margin-top: 0px;
        font-size: 13px;
        height: 22px;
        line-height: 17px;
        padding-left: 10px;
        color: @hui;

        i {
          color: @color;
          font-size: 15px;
        }
      }
    }

    .edit-but {
      margin-left: 100px;
      margin-right: 80px;
      margin-top: 14px;
    }

    .del-but {
      margin-right: 50px;
      color: @hong;
    }
  }
}
</style>
